import Button from "components/formElements/Button/Button";
import NotFoundImage from "images/404.png";
import "./style.css";
import TalaeraRoutes from "components/routes/TalaeraRoutes";
import { useNavigate } from "react-router-dom";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  title?: string;
  description?: string;
  children?: ReactElement;
};

export const WrongLinkPage = (props: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleDashboard = () => {
    navigate(TalaeraRoutes.ROOT.path);
  };

  const handleSignOut = () => {
    navigate(TalaeraRoutes.SIGN_OUT.path);
  };

  return (
    <div className="error-container">
      <div className="error-content-container">
        <div className="error-conatiner-right">
          <span className="error-heading">Oops!</span>

          <span className="error-title">{props.title || t("ErrorPage.signedIn")} </span>

          <span className="error-description">
            {props.description || t("ErrorPage.signOutFirst")}
          </span>

          <div className="error-button-container">
            {props.children || (
              <>
                <Button className={"btn btn-primary"} onClick={handleSignOut}>
                  {t("ErrorPage.signMeOut")}
                </Button>
                <Button
                  className={"btn btn-text btn-secondary"}
                  onClick={handleDashboard}
                >
                  {t("ErrorPage.toDashboard")}
                </Button>
              </>
            )}
          </div>
        </div>
        <div className="error-conatiner-left">
          <img src={NotFoundImage} alt="403" />
        </div>
      </div>
    </div>
  );
};
